import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BizTabs, { BizTab } from '../../Core/Components/Mini/BizTabs';
import { BizButton } from '../../Core/Components/Mini/BizButton';
import { useTimereportSettings } from '../../Core/Hooks/admin/useTimereportSettings';
import { useGlobalState } from '../../Core/Contexts/globalStateContext';
// import TimereportWeekView from './TimeEntry/TimereportWeekView';
import TimereportList from './TimeEntry/TimereportList';
// import TimereportCalendar from './TimeEntry/TimereportCalendar';
// import TimereportSubmitDialog from './Submit/TimereportSubmitDialog';
// import TimereportAttestOverview from './Attest/TimereportAttestOverview';
//import TimereportUserOverview from './Overview/TimereportUserOverview';
import TimereportUserYear from './Leave/TimereportUserYear';
import LeaveApplicationForm from './Leave/LeaveApplicationForm';
// import VacationApplication from './Vacation/VacationApplication';
// import VacationBalance from './Vacation/VacationBalance';
// import TravelExpenseMain from './Travel/TravelExpenseMain';
import ExpenseMain from './Expense/ExpenseMain';
import DriverLogMain from './DriverLog/DriverLogMain';
import TimereportReportView from './TimereportReportView';
// import TimereportWarnings from './Warnings/TimereportWarnings';
// import TimereportStatistics from './Statistics/TimereportStatistics';
import './TimereportMain.scss';
import TimereportUserOverview from './Overview/TimereportUserOverview';
import { useGetExpenseFeatureSettings } from '../../Core/Hooks/useTravelReport';
// import TimereportDayView from './TimeEntry/TimereportDayView';
// import { AccessTypeRight } from '../../Core/Types/access';
// import { hasModuleAccess, isAdministrator } from '../../Core/Services/access';
// import { useGlobalState } from '../../Core/Contexts/globalStateContext';

type TimereportTab =
	| 'reportTime'
	| 'reportExpenses'
	| 'day'
	| 'week'
	| 'calendar'
	| 'list'
	| 'overview'
	| 'submit'
	| 'attest'
	| 'vacation'
	| 'travel'
	| 'driverlog'
	| 'warnings'
	| 'statistics';

const TimereportMain = () => {
	// const {
	//         state: { user },
	//     } = useGlobalState();
	const { t } = useTranslation();
	const [selectedTab, setSelectedTab] = useState<TimereportTab>('reportTime');
	const { settings } = useTimereportSettings();
	const { expenseFeatureSettings } = useGetExpenseFeatureSettings();
	const { showModal } = useGlobalState();
	//const isAdmin = isAdministrator(user) || hasModuleAccess(user, 'TIMEREPORT', AccessTypeRight.Admin) || true;

	const tabs: BizTab[] = [
		{ key: 'reportTime', title: t('TIMEREPORT_USER.MAIN.TABS.REPORT_TIME') },
		{
			key: 'reportExpenses',
			title: t('TIMEREPORT_USER.MAIN.TABS.REPORT_EXPENSES'),
			visible:
				expenseFeatureSettings?.enabled === true &&
				(expenseFeatureSettings.receiptExpensesEnabled || expenseFeatureSettings.mileageReimbursementEnabled),
		},
		// { key: 'day', title: 'Day' },
		// { key: 'week', title: 'Week' },
		// { key: 'calendar', title: 'Calendar' },
		//{ key: 'list', title: t('TIMEREPORT_USER.MAIN.TABS.LIST') },//hide for now
		{ key: 'overview', title: t('TIMEREPORT_USER.MAIN.TABS.OVERVIEW') },
		// { key: 'submit', title: 'Submit' },
		// { key: 'attest', title: 'Attest' },
		// { key: 'vacation', title: 'Vacation' },
		{ key: 'driverlog', title: t('TIMEREPORT_USER.MAIN.TABS.DRIVER_LOG'), visible: settings?.driverLogEnabled ?? false },
		// { key: 'warnings', title: 'Warnings', visible: isAdmin },
		// { key: 'statistics', title: 'Statistics', visible: isAdmin },
	];

	const renderContent = () => {
		switch (selectedTab) {
			case 'reportTime':
				return <TimereportReportView />;
			case 'reportExpenses':
				return <ExpenseMain />;
			// case 'day':
			// 	return <TimereportDayView />;
			// case 'week':
			// 	return <TimereportWeekView />;
			// case 'calendar':
			// 	return <TimereportCalendar />;
			case 'list':
				return <TimereportList />;
			case 'overview':
				return (
					<>
						{/* hide for now */}
						<TimereportUserOverview />
						<BizButton
							isLead={true}
							legacy={false}
							style={{ marginBottom: '16px' }}
							text={t('TIMEREPORT_USER.MAIN.ACTIONS.APPLY_FOR_LEAVE')}
							onClick={() => showModal(<LeaveApplicationForm />, t('TIMEREPORT_USER.MAIN.ACTIONS.APPLY_FOR_LEAVE'))}
							icon='fa-solid fa-plus'
						/>
						<TimereportUserYear />
					</>
				);
			// case 'submit':
			// 	return <TimereportSubmitDialog />;
			// case 'attest':
			// 	return <TimereportAttestOverview />;
			// case 'vacation':
			// 	return (
			// 		<>
			// 			<VacationBalance />
			// 			<VacationApplication />
			// 		</>
			// 	);
			// case 'travel':
			// 	return <TravelExpenseMain />;
			case 'driverlog':
				return <DriverLogMain />;
			// case 'warnings':
			// 	return <TimereportWarnings />;
			// case 'statistics':
			// 	return <TimereportStatistics />;
		}
	};

	return (
		<div className='biz-timereport-main'>
			<div className='biz-timereport-main__header'>
				<h2 className='biz-timereport-main__title'>{t('TIMEREPORT_USER.MAIN.TITLE')}</h2>
			</div>
			<BizTabs
				tabs={tabs}
				selectedTabKey={selectedTab}
				onClick={(key) => setSelectedTab(key as TimereportTab)}
				ariaLabel={t('TIMEREPORT_USER.MAIN.NAVIGATION_ARIA')}
			/>
			<div className='biz-timereport-main__content'>{renderContent()}</div>
		</div>
	);
};

export default TimereportMain;
